<template>
  <section>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
      <Dialog header="Employee SubGroup" :visible.sync="displayBasic"
              :style="{width: '40vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="name">Name<span style="color:red">*</span></label>
            <InputText v-model.trim="name"  id="name"/>
          </div>

        <div class="p-field p-col-12 p-md-6">
            <label for="employeeGroupId">Employee Group</label>
            <Dropdown v-model="employeeGroupId" optionLabel="value" placeholder="Select Employee Group"
                      :filter="true" :options="employeeGroupLists"
                      :showClear="true" id="employeeGroupId"/>
          </div>
        </div>
        <template #footer>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <Button class="p-button-raised" @click.prevent="addEmployeePosition" :label="!editing?'Add':'Update'"/>
              <Button class="p-button-raised p-button-info" v-if="!editing"
                      label="Add & New"/>
              <Button  class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
            </div>
          </div>
        </template>
      </Dialog>
       <employeePositionList @employee-Position="editEmployeePosition"  @delete-message="deleteMessage" />
    </form>
  </section>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import DeleteDialog from '../../../layout/dialog'
import Column from 'primevue/column'
import Dropdown from 'primevue/dropdown'
import employeePositionList from './employeePositionList.vue'
export default {
  name: 'employeePosition',
  data() {
    return {
      displayBasic: false,
      name: '',
      loading: false,
      editing: false,
      employeeGroupId: null,
      employeePositionId: null,
      deleteDialog: false,
      employeeGrpId: 0,
      filters: {}
    }
  },
  computed: {
    employeeGroupLists() {
      return this.$store.state.hr.employeeGroupListsDropdown
    }
  },
  mounted() {
    this.employeeGroupList()
  },
  methods: {
    async addEmployeePosition() {
      if (this.name === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Name cannot be empty!', life: 3000})
        return
      }
      if (this.employeeGroupId === undefined) {
        this.employeeGroupId == null
        this.employeeGrpId = 0
      } else {
        this.employeeGrpId = this.employeeGroupId.id
      }
      let employeePosition = {
        id: this.employeePositionId,
        value: this.name,
        type: 'EmployeePosition',
        parentId: this.employeeGrpId
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createHrMasterSetup', employeePosition)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateHrMasterSetup', employeePosition)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    async employeeGroupList() {
      await this.$store.dispatch('loadHrMasterForDropdownList', 'EmployeeGroup')
    },
    reset() {
      this.name = ''
      this.displayBasic = false
      this.parentId = null
    },
    openBasic() {
      this.displayBasic = true
    },
    cancel() {
      this.displayBasic = false
    },
    editEmployeePosition(data) {
      this.editing = true
      this.id = data.id
      this.name = data.name
      if (data.parentId !== undefined) {
        // this.employeeGroupId == null
        this.employeeGroupId = data.parent
      }
      this.openBasic()
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    DataTable,
    Column,
    DeleteDialog,
    Dropdown,
    employeePositionList
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// employeePosition.vue?7c43f000